import React, { Component } from 'react';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import ProductGroupHistoryTable from '~/ProductGroupHistoryTable';
import Button from '~/UI/Button';
import secondarySmallButtonStyles from '~/UI/Button/secondary-small.less';
import Heading from '~/UI/Heading/Heading';
import ModalBody from '~/UI/Modal/Body/ModalBody';
import ModalContent from '~/UI/Modal/Content/ModalContent';
import ModalFooter from '~/UI/Modal/Footer/ModalFooter';
import ModalHeader from '~/UI/Modal/Header/ModalHeader';
import Modal from '~/UI/Modal/Modal';

import styles from './styles.less';

interface Props {
	group: UserProductGroup;
	onClose(): void;
}

export default class HistoryModal extends Component<Props> {
	render() {
		const { group, onClose } = this.props;

		return (
			<Modal onClose={onClose}>
				<ModalContent>
					<ModalHeader>
						<Heading>{group.name} history log</Heading>
					</ModalHeader>
					<ModalBody>
						<ProductGroupHistoryTable showProductName groupId={group.id} />
					</ModalBody>
					<ModalFooter>
						<div className={styles.buttons}>
							<Button styles={secondarySmallButtonStyles} onClick={onClose}>
								Close
							</Button>
						</div>
					</ModalFooter>
				</ModalContent>
			</Modal>
		);
	}
}
